export function NotFound() {
  return (
    <div className="flex gap-x-2 w-full h-full basis-full justify-center items-center">
      <h2 className="text-2xl font-bold">404</h2>
      <p className="text-lg font-semibold">Sidan hittades inte...</p>
    </div>
  );
}
